import { markupFormatter } from "../../../common";
import { BlockMarkupItem, BlockMarkupItemType, PlainTextMarkup } from "../../../common/markup/markup.interface";

// Список предлогов, которые не должны быть частью тега
const prepositions = [
    // Русские предлоги
    'в', 'на', 'с', 'к', 'у', 'о', 'об', 'от', 'по', 'из', 'за', 'для', 'над', 'под', 'при', 'про', 'без', 'до', 'через',
    // Английские предлоги
    'in', 'on', 'at', 'to', 'for', 'with', 'by', 'from', 'of', 'about', 'over', 'under', 'through', 'between', 'among', 'across',
    // Греческие предлоги и артикли
    'σε', 'από', 'με', 'για', 'προς', 'παρά', 'κατά', 'μετά', 'αντί', 'υπέρ', 'εναντίον', 'μεταξύ', 'πριν', 'μετά',
    'ο', 'η', 'το', 'οι', 'τα', 'του', 'της', 'των', 'τον', 'την', 'τους', 'τις', 'τα', 'ένας', 'μία', 'ένα', 'στο', 'στη', 'στον', 'στην', 'στους', 'στις', 'στα'
];

/**
 * Извлекает текст из блока разметки
 */
function extractTextFromBlock(block: BlockMarkupItem[]): string {
    return block
        .filter(item => item.type === BlockMarkupItemType.PlainText)
        .map(item => (item as PlainTextMarkup).text)
        .join(' ');
}

/**
 * Проверяет, является ли слово предлогом
 */
function isPreposition(word: string): boolean {
    return prepositions.includes(word.toLowerCase());
}

/**
 * Генерирует тег из текста, удаляя предлоги
 */
function generateTagFromText(text: string): string | null {
    // Разбиваем текст на слова и удаляем пустые строки
    const words = text.split(/\s+/).filter(word => word.trim().length > 0);
    
    // Если текст содержит больше 2 слов, он не подходит для тега
    if (words.length > 2) {
        return null;
    }
    
    // Если текст содержит 1-2 слова
    if (words.length === 1) {
        // Если это одно слово и оно не предлог, используем его как тег
        return isPreposition(words[0]) ? null : words[0].toLowerCase();
    } else if (words.length === 2) {
        // Если первое слово - предлог, используем только второе слово
        if (isPreposition(words[0])) {
            return words[1].toLowerCase();
        }
        // Иначе используем оба слова
        return words.join(' ').toLowerCase();
    }
    
    return null;
}

/**
 * Генерирует теги на основе вопроса и ответа в разметке карточки
 */
export function generateTagsFromMarkup(markup: string): string[] {
    const tree = markupFormatter.parse(markup);
    const tags: string[] = [];
    
    // Получаем текст вопроса
    const questionText = extractTextFromBlock(tree.question);
    const questionTag = generateTagFromText(questionText);
    if (questionTag !== null && questionTag !== '') {
        tags.push(questionTag);
    }
    
    // Получаем текст ответа
    const answerText = extractTextFromBlock(tree.answer);
    const answerTag = generateTagFromText(answerText);
    if (answerTag !== null && answerTag !== '' && answerTag !== questionTag) {
        tags.push(answerTag);
    }
    
    return tags;
}
